// extracted by mini-css-extract-plugin
export var musicHolder = "Pages-module--musicHolder--48lwL";
export var musicNav = "Pages-module--musicNav--vv7_6";
export var releasesHolder = "Pages-module--releasesHolder--2pu8f";
export var releaseHolder = "Pages-module--releaseHolder--POqL2";
export var videosHolder = "Pages-module--videosHolder--2ipBO";
export var videoHolder = "Pages-module--videoHolder--3dxug";
export var liveHolder = "Pages-module--liveHolder--Sr_9u";